<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>角色管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.name">
                <el-input v-model="role_name" placeholder="请输入名称" @keyup.enter.native="getList(0, 1)" clearable></el-input>
            </div>
            <div class="main_header_item" v-if="postList.status">
                <el-select filterable v-model="status" placeholder="请选择状态" clearable>
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="type"
                    model_name="请选择类型"
                    select_value="value"
                    request_uri="dropdownRoleType"
                    :model_value_default="type"
                    @onDropChange="onDropChange"
                    ref="type_ref"
                ></vDropdown>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" icon="el-icon-plus" plain @click="addRole(2)" v-if="postList.addBtn">新增角色</el-button>
                <el-button size="small" plain @click="allDelate" :loading="btnLoading" v-if="postList.delateBtn">批量删除</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <crm-upload obj="role"></crm-upload>
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="role"
                @selection-change="selectionChange"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="item.prop == 'status'">
                                <span v-if="scope.row.status == 1" class="status_1">启用</span>
                                <span v-else class="status_2">禁用</span>
                            </div>
                            <div v-else-if="item.prop == 'type'">
                                <span v-if="scope.row.type == 1">接口权限</span>
                                <span v-else-if="scope.row.type == 2">字段权限</span>
                                <span v-else>行级权限</span>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="handleDetail(scope.$index, scope.row, 1)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="handleDelate(scope.$index, scope.row)"></i>
                        </el-tooltip>

                        <el-tooltip v-if="scope.row.type == 1" class="item" effect="dark" content="接口权限" placement="top-start">
                            <i class="el-icon-s-grid" @click="handleAdd(scope.$index, scope.row)"></i>
                        </el-tooltip>
                        <el-tooltip v-else-if="scope.row.type == 2" class="item" effect="dark" content="字段权限" placement="top-start">
                            <i class="el-icon-error" @click="setField(scope.$index, scope.row)"></i>
                        </el-tooltip>
                        <el-tooltip v-else class="item" effect="dark" content="行级权限" placement="top-start">
                            <i class="el-icon-remove" @click="setRow(scope.$index, scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
        <!-- 弹出框 新增 编辑 -->
        <el-dialog
            :close-on-click-modal="false"
            v-dialogDrag
            :title="header_title"
            :visible.sync="dialogVisible"
            width="500px"
            :before-close="handleClose"
        >
            <el-form ref="form" :model="form" label-width="100px" :rules="rules">
                <el-form-item label="角色名" prop="role_name">
                    <el-input v-model="form.role_name" clearable placeholder="请输入角色名"></el-input>
                </el-form-item>
                <el-form-item label="角色描述" prop="role_desc">
                    <el-input v-model="form.role_desc" clearable placeholder="请输入角色描述"></el-input>
                </el-form-item>
                <el-form-item label="角色状态" prop="role_resource">
                    <el-radio-group class="dialog_radio" v-model="form.role_resource">
                        <el-radio label="1">启用</el-radio>
                        <el-radio label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="角色类型" prop="type_resource" v-if="middleType != 1">
                    <el-radio-group class="dialog_radio" v-model="form.type_resource">
                        <el-radio label="1">接口权限</el-radio>
                        <el-radio label="2">字段权限</el-radio>
                        <el-radio label="3">行级权限</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancleData('form')">取 消</el-button>
                <el-button type="primary" @click="okData('form')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 绑定权限 -->
        <el-dialog
            :close-on-click-modal="false"
            v-dialogDrag
            title="绑定权限"
            :visible.sync="dialogVisibles"
            width="500px"
            :before-close="handleCloses"
        >
            <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
            <el-tree
                class="filter-tree"
                :data="data"
                show-checkbox
                node-key="id"
                :props="defaultProps"
                default-expand-all
                :filter-node-method="filterNode"
                :default-checked-keys="defaultCheckedKeys"
                ref="tree"
            ></el-tree>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibles = false">取 消</el-button>
                <el-button type="primary" @click="okDatas" :loading="down_loading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { onReSize } from '../../../../js/common';
import draggableList from '../../../common/Drawer.vue';
import crmUpload from '@/components/common/Upload.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload
    },
    name: 'roleManagementComponent',
    data() {
        return {
            rules: {
                role_name: [{ required: true, message: '请输入角色名', trigger: 'blur' }],
                role_resource: [{ required: true, message: '请选择角色状态', trigger: 'blur' }],
                type_resource: [{ required: true, message: '请选择角色类型', trigger: 'blur' }]
            },
            draggable: {
                data_name: 'role'
            },
            down_loading: false,
            loading: false,
            colData: [],
            header_title: '',
            name: '',
            total: 0,
            page: 1,
            row: 25,
            middleType: '',
            id: '',
            role_desc: '',
            role_resource: '',
            type_resource: '',
            dialogVisible: false,
            dialogVisibles: false,
            listLoading: false, //加载数据中
            tableData: [],
            form: {
                role_name: '',
                role_desc: '',
                role_resource: '',
                type_resource: ''
            },
            role_name: '', //角色名
            btnLoading: false,
            options: [
                {
                    value: '1',
                    label: '启用'
                },
                {
                    value: '0',
                    label: '禁用'
                }
            ],
            status: '',
            type: '',
            selected: [],
            filterText: '',
            data: [],
            defaultCheckedKeys: [],
            defaultProps: {
                children: 'subs',
                label: 'title'
            }
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['role_params']) {
                this.page = paramsList['role_params'].page;
                this.row = paramsList['role_params'].row;
                this.role_name = paramsList['role_params'].role_name;
                this.status = paramsList['role_params'].status;
                this.type = paramsList['role_params'].type;
                // this.data_name = paramsList['role_params'].data_name;
                // this.sort = paramsList['role_params'].sort;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('role', this, 1);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).role;
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['role_params']) {
                    newParamsList['role_params'].data_name = val.prop;
                    newParamsList['role_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                role_name: this.role_name,
                status: this.status,
                type: this.type,
                page: this.page,
                sort: [this.data_name, this.sort],
                row: this.row,
                is_export: type_data
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['role_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .roleLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['role_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            } else {
                this.down_loading = true;
                params.page = 1;
                this.$api
                    .commodityFlowSourceListsDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
                        this.down_loading = false;
                    });
            }
        },
        addRole(type) {
            this.header_title = '新增';
            this.middleType = type;
            this.dialogVisible = true;
            this.form.role_resource = '1';
            this.form.type_resource = '1';
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['role_params']) {
                    newParamsList['role_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        role_name: this.role_name,
                        status: this.status,
                        type: this.type,
                        page: this.page,
                        sort: [this.data_name, this.sort],
                        row: this.row
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['role_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['role_params']) {
                    newParamsList['role_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        role_name: this.role_name,
                        status: this.status,
                        type: this.type,
                        page: this.page,
                        sort: [this.data_name, this.sort],
                        row: this.row
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['role_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        //重置页面数据
        reset() {
            this.role_name = '';
            this.status = '';
            this.type = '';
            this.page = 1;
            this.row = 25;
            var params = {
                page: 1,
                row: 25,
                sort: ['', ''],
                role_name: '',
                status: '',
                type: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            newParamsList['role_params'] = params;
            localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            this.getList(0);
        },
        //过滤筛选条件
        filterNode(value, data) {
            if (!value) return true;
            return data.title.indexOf(value) !== -1;
        },
        onDropChange(key, value) {
            if (key == 'type') {
                this.type = value;
            }
        },
        //批量删除
        allDelate() {
            let idList = this.selected.map((item) => item.id);
            if (this.selected.length == 0) {
                this.$message({
                    type: 'warning',
                    message: '还未选择数据'
                });
            } else {
                this.btnLoading = true;
                this.$msgbox('此操作将删除该角色, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        let params = {
                            ids: idList
                        };
                        this.$api
                            .batchDelete(params)
                            .then((res) => {
                                this.middleType = '';
                                if (res.code == 0) {
                                    this.btnLoading = false;
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.getList(0); //获取角色列表
                                }
                            })
                            .catch((error) => {
                                this.btnLoading = false;
                            });
                    })
                    .catch(() => {
                        this.btnLoading = false;
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
            }
        },
        addRole(type) {
            this.header_title = '新增';
            this.middleType = type;
            this.dialogVisible = true;
            this.form.role_resource = '1';
            this.form.type_resource = '1';
            this.form.role_name = '';
            this.form.role_desc = '';
        },
        //点击取消
        cancleData(form) {
            this.form.role_name = '';
            this.form.role_desc = '';
            this.form.role_resource = '';
            this.form.type_resource = '';
            this.id = '';
            this.dialogVisible = false;
            this.$refs[form].resetFields();
        },
        //关闭前清空内容
        handleClose() {
            this.form.role_name = '';
            this.form.role_desc = '';
            this.form.role_resource = '';
            this.form.type_resource = '';
            this.id = '';
            this.dialogVisible = false;
        },
        handleCloses() {
            this.dialogVisibles = false;
        },
        //提交数据
        okData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.middleType == 1) {
                        let params = {
                            role_name: this.form.role_name,
                            description: this.form.role_desc,
                            status: this.form.role_resource,
                            type: this.form.type_resource,
                            id: this.id
                        };
                        this.$api
                            .roleUpdate(params)
                            .then((res) => {
                                this.middleType = '';
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '修改成功',
                                        type: 'success'
                                    });
                                    this.dialogVisible = false;
                                    this.form.role_desc = '';
                                    this.form.role_resource = '';
                                    this.form.type_resource = '';
                                    this.id = '';
                                    this.getList(0); //获取角色列表
                                }
                            })
                            .catch((error) => {});
                    } else if (this.middleType == 2) {
                        let params = {
                            role_name: this.form.role_name,
                            description: this.form.role_desc,
                            status: this.form.role_resource,
                            type: this.form.type_resource
                        };
                        this.$api
                            .roleInsert(params)
                            .then((res) => {
                                this.middleType = '';
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '新增成功',
                                        type: 'success'
                                    });
                                    this.dialogVisible = false;
                                    this.form.role_desc = '';
                                    this.form.role_resource = '';
                                    this.form.type_resource = '';
                                    this.getList(0); //获取角色列表
                                }
                            })
                            .catch((error) => {});
                    }
                }
            });
        },
        //提交数据
        okDatas() {
            this.down_loading = true;
            let ids = this.$refs.tree.getCheckedNodes(false, true).map((item) => item.id);
            let params = {
                permissions: ids,
                id: this.id
            };
            this.$api
                .savePermissions(params)
                .then((res) => {
                    this.middleType = '';
                    if (res.code == 0) {
                        this.$message({
                            showClose: true,
                            message: '添加成功',
                            type: 'success'
                        });
                        this.down_loading = false;
                        this.dialogVisibles = false;
                        this.getList(0); //获取角色列表
                    }
                })
                .catch((error) => {
                    this.down_loading = false;
                });
        },
        // 多选选择框选择
        selectionChange(val) {
            this.selected = val;
        },
        checkSelectable(row) {
            return row.status === 1;
        },
        // 查看详情
        handleDetail(index, row, type) {
            this.header_title = '编辑';
            this.middleType = type;
            this.dialogVisible = true;
            this.id = row.id;
            this.form.role_name = row.role_name;
            this.form.role_desc = row.description;
            if (row.status == 1) {
                this.form.role_resource = '1';
            } else {
                this.form.role_resource = '0';
            }
            if (row.type == 1) {
                this.form.type_resource = '1';
            } else {
                this.form.type_resource = '0';
            }
        },
        //删除当前行
        handleDelate(index, row) {
            this.$msgbox('此操作将删除该角色, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let id = [row.id];
                    let params = {
                        ids: id
                    };
                    this.$api
                        .batchDelete(params)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.getList(0); //获取角色列表
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        //绑定权限
        handleAdd(index, row) {
            this.dialogVisibles = true;
            this.id = row.id;
            let params = {
                role_id: this.id
            };
            this.$api
                .getPermissionsWithRole(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.data = res.data.data;
                        this.defaultCheckedKeys = res.data.default_checked_keys;
                    }
                })
                .catch((error) => {});
        },
        setField(index, row) {
            this.$router.push({
                path: '/roleField',
                query: {
                    id: row.rid,
                    role_name: row.role_name
                }
            });
        },
        setRow(index, row) {
            this.$router.push({
                path: '/roleRow',
                query: {
                    id: row.rid,
                    role_name: row.role_name
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.status_1 {
    color: green;
}
.status_2 {
    color: red;
}
</style>